<template>
    <div id="profile-page" class="wide content">
        <h3>Edit Profile</h3>

        <div class="edit">
            <form @submit.prevent="saveUser">
                <p>
                    <label>First Name
                        <input type="text" name="firstname" v-model="editUser.firstname" required>
                    </label>
                </p>
                <p>
                    <label>Last Name
                        <input type="text" name="lastname" v-model="editUser.lastname" required>
                    </label>
                </p>
                <p>
                    <label>Industry Role
                        <input type="text" name="industry_role" v-model="editUser.industry_role" placeholder="Select or enter your role" list="role_list" autocomplete="one-time-code" required>
                        <datalist id="role_list">
                            <option value="Bank Office/Operations" />
                            <option value="Data Provider" />
                            <option value="Trustee" />
                            <option value="Lender" />
                            <option value="Investor" />
                            <option value="Issuer" />
                            <option value="NSRO" />
                            <option value="Servicer" />
                            <option value="Underwriter" />
                        </datalist>
                    </label>
                </p>
                <p>
                    <label>Company
                        <input type="text" name="company" v-model="editUser.company" required>
                    </label>
                </p>
                <p>
                    <label>Address
                        <input type="text" name="address" v-model="editUser.address" required>
                    </label>
                </p>
                <p>
                    <label>Suite/Apt
                        <input type="text" name="address2" v-model="editUser.address2">
                    </label>
                </p>
                <p>
                    <label>City
                        <input type="text" name="city" v-model="editUser.city" required>
                    </label>
                </p>
                <p>
                    <label>State
                        <input type="text" name="state" v-model="editUser.state" required>
                    </label>
                </p>
                <p>
                    <label>ZIP Code
                        <input type="text" name="zipcode" v-model="editUser.zipcode" required>
                    </label>
                </p>
                <p>
                    <label>Email
                        <input type="email" name="email" v-model="editUser.email" required>
                    </label>
                </p>
                <p>
                    <label>Work Phone
                        <input type="tel" name="workphone" v-model="editUser.work_phone">
                    </label>
                </p>
                <p>
                    <label>Change Password
                        <input type="password" name="password" v-model="editUser.password">
                    </label>
                </p>
                <p>
                    <label>Confirm Password
                        <input type="password" name="confirm_password" v-model="editUser.confirm_password" :required="!!editUser.password">
                        <small v-if="editUser.password != editUser.confirm_password">
                            Passwords do not match
                        </small>
                    </label>
                </p>
                <p>
                    <button>Save</button>
                </p>
            </form>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'profile',
    data() {
        return {
            editUser: {},
        }
    },
    methods: {
        async getProfile() {
            let r = await axios.get('/api/users/me')
            this.editUser = r.data.user
        },
        async saveUser() {
            if (this.editUser.password != this.editUser.confirm_password) {
                return false;
            }

            let r = await axios.post('/api/users/me', {
                    user: this.editUser
                })

            if (r.status != 200) {
                return;
            }

            this.getProfile()
            this.$notify.success('Profile Saved!', 2000)
        },
    },
    created() {
        this.getProfile()
    },
}
</script>
<style lang="scss">
@import '../scss/include-media';
#profile-page {
    padding: 50px 100px;
    @include media("<=tablet") {
        padding: 50px;
    }
    &.content {
        @include media(">tablet") {
            max-width: 65vw;
        }
    }
    min-height: 55vh;

    .edit {
        @include media('>tablet') {
            max-width: 45vw;
        }
        label {
            display: block;
        }
    }


}
</style>
